import React from 'react';
import { Image } from 'lucide-react';
import { UploadArea } from './FormComponents';
import './CourseCreationTabs.css';

export interface MediaTabProps {
  thumbnailFile: File | null;
  onThumbnailUpload: (file: File) => void;
  onThumbnailRemove: () => void;
  validationErrors: Record<string, string>;
}

export const MediaTab: React.FC<MediaTabProps> = ({
  thumbnailFile,
  onThumbnailUpload,
  onThumbnailRemove,
  validationErrors,
}) => {
  return (
    <div className="tab-content">
      {/* Section Header */}
      <div className="section-header media-header">
        <h3>
          <Image size={20} />
          Media & Assets
        </h3>
        <p>Upload visual content to make your course attractive</p>
      </div>

      {/* Thumbnail Upload */}
      <div className="media-section">
        <div className="media-info">
          <h4>Course Thumbnail</h4>
          <p className="media-description">
            Upload an eye-catching image that represents your course. This will be displayed
            on the course card and course page.
          </p>
          <ul className="media-requirements">
            <li>Recommended size: 1280 x 720 pixels (16:9 ratio)</li>
            <li>Supported formats: JPG, PNG, GIF</li>
            <li>Maximum file size: 5MB</li>
            <li>Use high-quality images for best results</li>
          </ul>
        </div>

        <div className="upload-container">
          <UploadArea
            onUpload={onThumbnailUpload}
            onRemove={onThumbnailRemove}
            file={thumbnailFile}
            error={validationErrors.thumbnail}
            accept="image/*"
            maxSize="5MB"
            icon={Image}
            title="Click to upload or drag and drop"
            description="PNG, JPG or GIF (recommended 1280 x 720px)"
          />
        </div>
      </div>

      {/* Additional Information */}
      <div className="info-box">
        <div className="info-icon">
          <Image size={16} />
        </div>
        <div>
          <strong>Tips for Great Thumbnails</strong>
          <ul className="tips-list">
            <li>Use clear, high-resolution images</li>
            <li>Include relevant imagery that represents the course topic</li>
            <li>Avoid cluttered designs - keep it simple and professional</li>
            <li>Ensure text (if any) is readable at small sizes</li>
            <li>Use consistent branding if you have multiple courses</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
